import InputGroupContent from '@/components/elements/input'
import Select from '@/components/elements/select'
import TextareaGroupContent from '@/components/elements/textarea'
import {
	GeneralDetailsAccessories,
	SpecificationsAccessories,
} from '@/entities/api/products/details'
import ProductEntity from '@/entities/api/products/products'
import { ageMap } from '@/utils/maps/age-map'
import { booleanMap } from '@/utils/maps/boolean-map'
import { genderMap } from '@/utils/maps/gender-map'
import { Box, Heading } from '@chakra-ui/react'
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form'

const AccessoriesForm = ({
	control,
	register,
	errors,
	product,
}: {
	control: Control<any>
	register: UseFormRegister<any>
	errors: FieldErrors<any>
	product?: ProductEntity
}) => {
	return (
		<>
			<Box
				w='full'
				display='flex'
				justifyContent='start'
				alignItems='center'
				mt='4'
			>
				<Heading
					as='h5'
					fontSize={{ base: 'md', md: 'lg' }}
					color='black'
					fontWeight='900'
				>
					Detalles generales
				</Heading>
			</Box>
			<InputGroupContent
				label='Modelo del accesorio'
				placeholder='Agrega el modelo del accesorio o alguna referencia'
				name='details.general_details.model'
				type='text'
				required
				defaultValue={
					(product &&
						(product?.details?.general_details as GeneralDetailsAccessories)
							.model) ||
					''
				}
				register={register}
				errors={errors}
			/>
			<Select
				name='details.general_details.gender'
				label='Genero del accesorio'
				placeholder='Escoge el genero del accesorio'
				defaultValue={
					(product &&
						genderMap.find(
							(obj) =>
								obj.value ===
								((
									product?.details?.general_details as GeneralDetailsAccessories
								)?.gender ?? '')
						)) ?? { label: '', value: '' }
				}
				options={genderMap}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.general_details.age'
				label='Seleciona el rango de eded del accesorio'
				placeholder='Escoge el rango de edad del accesorio'
				options={ageMap}
				defaultValue={
					product &&
					(ageMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.general_details as GeneralDetailsAccessories)
								?.age ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<TextareaGroupContent
				label='Materiales del accesorio'
				placeholder='Ingresa la descripcion de los materiales del accesorio'
				name='details.general_details.materials'
				required
				defaultValue={
					(product &&
						(product?.details?.general_details as GeneralDetailsAccessories)
							.materials) ||
					''
				}
				type='text'
				register={register}
				errors={errors}
			/>
			<Box
				w='full'
				display='flex'
				justifyContent='start'
				alignItems='center'
				mt='4'
			>
				<Heading
					as='h5'
					fontSize={{ base: 'md', md: 'lg' }}
					color='black'
					fontWeight='900'
				>
					Especificaciones
				</Heading>
			</Box>
			<Select
				name='details.specifications.is_non_slip'
				label='¿Es antideslizante?'
				placeholder='Escoge si el accesorio es antideslizante'
				options={booleanMap}
				defaultValue={
					product &&
					(booleanMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.specifications as SpecificationsAccessories)
								?.is_non_slip ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.specifications.is_adjustable'
				label='¿Es ajustable?'
				placeholder='Escoge si el accesorio es ajustable'
				options={booleanMap}
				defaultValue={
					product &&
					(booleanMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.specifications as SpecificationsAccessories)
								?.is_adjustable ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
		</>
	)
}

export default AccessoriesForm
